"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TOKEN_PROGRAM_ID = void 0;
var web3_js_1 = require("@solana/web3.js");
exports.TOKEN_PROGRAM_ID = new web3_js_1.PublicKey('TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA');
//# sourceMappingURL=splToken.js.map